const collator = new Intl.Collator();

export const SORTS = {
  item: { defaultDirection: 'asc', compare: (a, b) => collator.compare(a.name, b.name) },
  unitsSold: { defaultDirection: 'desc', compare: (a, b) => a.unitsSold - b.unitsSold },
  orders: { defaultDirection: 'desc', compare: (a, b) => a.ordersCount - b.ordersCount },
  earnings: { defaultDirection: 'desc', compare: (a, b) => (a.earnings?.amount || 0) - (b.earnings?.amount || 0) },
};

export const sortItems = (items, { key, direction }) => {
  const sign = direction === 'desc' ? -1 : 1;
  return [...items].sort((a, b) => sign * SORTS[key].compare(a, b));
};

export const sharedAcrossGroup = venueItems => {
  const same = pick => venueItems.every(venueItem => pick(venueItem) === pick(venueItems[0]));
  return {
    venue: same(venueItem => venueItem.venueId),
    menus: same(venueItem => [...venueItem.menus].sort().join('\u0000')),
    categories: same(venueItem => [...venueItem.categories].sort().join('\u0000')),
  };
};
